import React, { useRef } from 'react'

import { connect } from 'react-redux'
import { AppState } from '@chegg-wt/core/state'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { HiddenLabel } from '@chegg-wt/core/components/HiddenLabel'
import { useOnClickOutside } from '@chegg-wt/core/hooks/useOnClickOutside'
import { useToggle } from '@chegg-wt/core/hooks/useToggle'
import {
  titleSelector,
  folderIndexSelector,
} from '@chegg-wt/core/state/folders/selectors'
import { ListSelectorProps } from '../../shared/ProjectMenu/types'
import * as Styled from './styled'

export const ListSelector: React.FunctionComponent<ListSelectorProps> = ({
  title,
  folderIndex = -1,
  className = '',
}) => {
  const {
    value: isFolderSettingsVisible,
    toggle: toggleFolderSettingsVisible,
    off: closeFolderSettings,
  } = useToggle()
  const {
    value: isFoldersListVisible,
    toggle: toggleFoldersListVisible,
    off: closeFolderListVisible,
  } = useToggle()
  const isFolderSettingsMenuButtonVisisble = folderIndex > -1
  const closeFoldersMenu = () => {
    closeFolderListVisible()
    closeFolderSettings()
  }
  const dropdown = useRef<HTMLDivElement>()

  useOnClickOutside(dropdown, closeFoldersMenu)

  return (
    <Styled.PositionedItemsLayout className={className} ref={dropdown}>
      <Styled.SubTitleContainer data-test="project-subtitle">
        <Styled.ListTitle title={title}>{title}</Styled.ListTitle>
        <Styled.FolderListMenuButton
          type="button"
          onClick={toggleFoldersListVisible}
          data-test="projects-folders-button"
        >
          <Styled.Icon icon={publicAssetUrl('triangle.svg')} iconSize="20px" />
          <HiddenLabel>Project Types and Folders Lists</HiddenLabel>
        </Styled.FolderListMenuButton>
        {isFolderSettingsMenuButtonVisisble && (
          <Styled.FolderSettingsMenuButton
            type="button"
            onClick={toggleFolderSettingsVisible}
            data-test="folder-settings-button-top"
          >
            <Styled.GearIcon />
            <HiddenLabel>Folder Settings</HiddenLabel>
          </Styled.FolderSettingsMenuButton>
        )}
      </Styled.SubTitleContainer>
      {isFoldersListVisible && (
        <Styled.MenuContainer>
          <Styled.ProjectMenu />
        </Styled.MenuContainer>
      )}
      {isFolderSettingsVisible && (
        <Styled.FolderSettingsMenu closeMenu={closeFolderSettings} index={folderIndex} />
      )}
    </Styled.PositionedItemsLayout>
  )
}

const mapStateToProps = (state: AppState) => ({
  title: titleSelector(state),
  folderIndex: folderIndexSelector(state),
})

export default connect(mapStateToProps)(ListSelector)
